import React from 'react';
import {Row, Col, Form, Label, Button} from "reactstrap";
import SelectEnti from "../Controls/SelectEnti.mjs";
import SelectAA from "../Controls/SelectAA.mjs";
import SelectAD from "../Controls/SelectAD.mjs";
import TsInterval from "../Controls/TsInterval.mjs";
import SelectSlot from "../Controls/SelectSlot.mjs";
import ShowSlot from "../Controls/ShowSlot.mjs";
import Lnote from "../Controls/Lnote.mjs";

class NuovaPrenotazione extends React.Component {
	constructor(opts) {
		super(opts);
		window.glob.slot.reset();
		this.state = {};
		this.toolbar.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.fieldchange = this.fieldchange.bind(this);
		this.save = this.save.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.uid = "NuovaPrenotazione-"+window.glob.generateUid();
		this.formData = {};
		this.defaultData = {};
		this.globPrefix = 'prenotazione.';
		window.glob.dropStatus([ this.globPrefix+'changed', this.globPrefix+'values' ]);
	};
	componentDidMount() {
		window.glob.register(this.globPrefix+'changed',(fieldKeyValue)=>{
			this.fieldchange(fieldKeyValue);
		}, this.uid );
		window.glob.register( this.globPrefix+'conflitto', c =>{
			this.setState({ conflitto: c });
			this.toolbar();
		}, this.uid );
		setTimeout( ()=>{ this.toolbar() } , 0);
	};
	componentWillUnmount() {
		window.glob.unregister([ this.globPrefix+'changed', this.state.prefix+'conflitto', 'toolbar' ], this.uid);
		window.glob.dropStatus([ this.globPrefix+'changed', this.globPrefix+'values' ]);
	};
	async fieldchange( w ) {
		if ( typeof w !== 'object') return;
		if ( typeof w.name !== 'string') return;
		const v = w.value;
		const revert = [];
		switch ( w.name ) {
			case 'lnote':
				this.formData.lnote = v;
				break;
			case 'ente':
				this.formData.ente = v;
				revert.push('slot','laa','of','tinizio','tfine');
				break;
			case 'slot':
				this.formData.slot = v;
				revert.push('laa','of','tinizio','tfine');
				break;
			case 'laa':
				this.formData.laa = v;
				revert.push('of','tinizio','tfine');
				break;
			case 'of':
				this.formData.of = v;
				revert.push('tinizio','tfine');
				break;
			case 'start_end':
				if ( Array.isArray(v) ) {
					this.formData.tinizio = v[0];
					this.formData.tfine = v[1];
				} else {
					revert.push('tinizio','tfine');
				}
				break;
			case 'conflictDetected' :
				this.formData.conflictDetected = v ? 1 : undefined;
				break;
			default: break;
		}
		await window.glob.setStatus(this.globPrefix+'values',this.formData);
		await window.glob.trigger(this.globPrefix+'changed.'+w.name,v);
		for (let i = 0; i < revert.length; i++) {
			const k = revert[i];
			this.formData[k] = this.defaultData[k];
			await window.glob.trigger(this.globPrefix+'changed.'+k,this.formData[k]);
		}
		this.formCompleted = !! (this.formData.of && this.formData.tfine);
		this.setState({ formConpleted: this.formCompleted });
		this.toolbar();
	}
	handleSubmit(e) {
		e.preventDefault();
	};
	save() {
		window.glob.slot.reset();
		if ( this.formCompleted ) {
			if ( this.formData.conflictDetected || this.state.conflitto ) if ( ! window.confirm("ATTENZIONE.\n\nSi sta scegliendo di inserire una prenotazione in conflitto con una prenotazione già presente, a meno di casi particolari la segreteria dovrà eliminarla.\n\nProcedere comunque?") ) return void(0);
			window.glob.api('save', this.formData ).then( (o)=>{
				window.glob.setStatus('operation','index');
			}).catch( (e)=>{
				console.error(e);
				window.alert("Si è verificato un errore salvando la prenotazione.\n\nProva ancora o Annulla.");
			});
		}
	};
	toolbar( timedOut ) {
		if ( ! timedOut ) {
			setTimeout( ()=>{ this.toolbar(true) }, 100);
			return;
		}
		let tb = (
			<Button
				onClick={()=>{ window.glob.setStatus('operation','index')}}
				color={"warning"}
				className={"btn-icon"}
			>
				<i>←</i>
				<b>Annulla</b>
			</Button>
		);
		let tb2;
		if ( this.state.conflitto ) {
			tb2 = <Label>Conflitto di orario<span className={"mobile-no"}>, impossibile salvare</span></Label>;
		} else if ( this.state.changed && this.formCompleted ) {
			tb2 = (
				<Button
					onClick={()=>{ this.save() } }
					color={ this.formData.conflictDetected ? "danger" : "success"}
					className={"btn-icon"}
					rel={"save"}
				>
					<i>✚</i>
					<b>Inserisci<span className={"mobile-no"}> la prenotazione</span></b>
				</Button>
			);
		} else {
			tb2 = <Label>Completare tutti i campi<span className={"mobile-no"}> per inserire la prenotazione</span></Label>;
		}
		setTimeout( ()=>{ window.glob.setStatus('toolbar',tb, tb2); }, 10 );
	};
	saveButton() {
		this.toolbar();
		if ( this.state.conflitto || ! this.formCompleted ) return "";
		return(
			<>
				<Lnote
					name={"lnote"}
					value={""}
					globPrefix={this.globPrefix}
				/>
				<Row>
					<Col lg={12} className={"pt-4 text-center"}>
						<div className={"d-inline-block"}>
							<Button
								onClick={()=>{ this.save() } }
								color={ this.formData.conflictDetected ? "danger" : "success"}
								className={"btn-icon"}
							>
								<i>✚</i>
								<b>Inserisci<span className={"mobile-no"}> la prenotazione</span></b>
							</Button>
						</div>
					</Col>
				</Row>
			</>
		);
	};
	render() {
		return (
			<Form onSubmit={this.handleSubmit} className={"NuovaPrenotazione"} id={this.uid}>
				<Row>
					<Col lg={3}>
						<Label>Corso di Laurea:</Label>
					</Col>
					<Col lg={8}>
						<SelectEnti
							name={"ente"}
							globPrefix={this.globPrefix}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={3}>
						<Label>Sessione di esame:</Label>
					</Col>
					<Col lg={8}>
						<SelectSlot
							name={"slot"}
							deps={{ente:"ente"}}
							globPrefix={this.globPrefix}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={3}>
						<Label>Anno Accademico:</Label>
					</Col>
					<Col lg={8}>
						<SelectAA
							name={"laa"}
							deps={{ente:"ente",slot:"slot"}}
							globPrefix={this.globPrefix}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={3}>
						<Label>Attività Didattica:</Label>
					</Col>
					<Col lg={8}>
						<SelectAD
							name={"of"}
							deps={{ente:"ente",aa:"laa"}}
							globPrefix={this.globPrefix}
						/>
					</Col>
				</Row>
				<ShowSlot globPrefix={this.globPrefix} />
				<TsInterval
					parent={ this.formData }
					name={"start_end"}
					deps={{field:"of",slot:"slot"}}
					globPrefix={this.globPrefix}
				/>
				{ this.saveButton() }
			</Form>
		);
	}
}

export default NuovaPrenotazione;